<template>
  <div
    v-if="queueReportStatus === 1"
    class="vx-row"
  >
    <div class="vx-col md:w-1/3 sm:w-full w-full">
      <statistics-item-card
        class="mb-3"
        style="background-color: #d3e986;"
        :title="$t('call_average')"
        :is-loading="isLoading"
        :display="`${queueAdditionalData && queueAdditionalData.srcCount.length > 0 ? (queueAdditionalData.srcCount.reduce((accumulator, object) => {
          return accumulator + object.total_count
        }, 0) / queueAdditionalData.srcCount.length).toFixed(2) : 0}`">
      </statistics-item-card>
    </div>

    <div class="vx-col md:w-1/3 sm:w-full w-full">
      <statistics-item-card
        class="mb-3"
        style="background-color: #d3e986;"
        :title="$t('talk_time_average')"
        :is-loading="isLoading"
        :display="`${queueAdditionalData ? parseInt(queueAdditionalData.average).toFixed(2) : 0}`">
      </statistics-item-card>
    </div>

    <div class="vx-col md:w-1/3 sm:w-full w-full">
      <statistics-item-card
        class="mb-3"
        style="background-color: #d3e986;"
        :title="$t('early_finish_rate')"
        :is-loading="isLoading"
        :display="`${queueAdditionalData ? queueAdditionalData.earlyFinishRate.toFixed(2) : 0}%`">
      </statistics-item-card>
    </div>
  </div>
</template>

<script>
import StatisticsItemCard from '@/components/cards/StatisticsItemCard'
import Queue from '@/models/Queue'

export default {
  components: {
    StatisticsItemCard
  },
  data () {
    return {
      isLoading: true
    }
  },
  props: {
    queueReportStatus: Boolean,
    extensions: Array
  },
  computed: {
    queueAdditionalData () {
      return this.$store.getters.queueAdditionalData
    }
  },
  async mounted () {
    await this.getAdditionalData()
    this.isLoading = false

    setInterval(() => {
      this.getAdditionalData()
    }, 300000) // 5 minutes
  },
  methods: {
    async getAdditionalData () {
      const extensions = this.extensions.map((extension) => {
        return extension.extension
      })
      const queueAdditionalData = await Queue.status({ extensions })
      this.$store.dispatch('setQueueAdditionalData', queueAdditionalData.data)
    }
  }
}
</script>

<style>

</style>
